import { html } from 'lit';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { getFAIcon, generateEnhancedShareUrl } from '../../masonry-utils';
import ShareBtn from './ShareBtn';

class EmailShareBtn extends ShareBtn {
  static get properties() {
    return {
      ...super.properties,
      post: { type: Object },
      shareTitle: { type: String },
    };
  }

  constructor() {
    super();
    this.icon = faEnvelope;
    this.color = '#666';
  }

  /**
   * Gets the email share URL with subject line and enhanced URL
   * @returns {string} Email share URL with subject and body
   */
  get shareURL() {
    const url = this.post ? generateEnhancedShareUrl(this.post) : window.location.href;
    const subject = encodeURIComponent(this.shareTitle || '');
    const body = encodeURIComponent(url);
    return `mailto:?subject=${subject}&body=${body}`;
  }

  render() {
    return html`
      <a href=${this.shareURL} class="web-share__btn" @click=${this.clickHandler}>
        ${getFAIcon(this.icon)}
      </a>
    `;
  }
}

export default EmailShareBtn;
